import { useMutation } from '@tanstack/react-query';

import { User } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { UpdateUserFormSchemaValues } from 'src/features/users/utils/formSchema';

const RESOURCE = '/users/user/:userId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    data: UpdateUserFormSchemaValues | { is_active: boolean };
    userId: string;
}
const mutationFn = ({ userId, data }: DTO): Promise<User> => {
    return axios.patch(formatResourcePath(RESOURCE, { userId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateUser };
